import type { PayinsTranslations } from "../interfaces/payins";

export const payinsTranslations: PayinsTranslations = {
  // Countries
  country_BRA: "Brasil",
  country_COL: "Colombia",
  country_MEX: "México",
  country_ARG: "Argentina",

  // Create page
  create_title: "Recibir dinero",
  create_subtitle: "De tus clientes, de forma rápida y segura",
  button_create: "Crear",
  error_create: "Error al crear el payin",
  error_no_org: "Tu usuario no tiene una organización asociada, no es posible crear el payin.",

  // Banner linking to the runtime payments activity view
  runtime_banner_text:
    "¿Buscas tus movimientos PIX (Brasil), SPEI (México), CBU/CVU (Argentina) o Bre-B (Colombia)? Se procesan en tiempo real y viven en la nueva vista de actividad.",
  runtime_banner_link: "Ver actividad de pagos",

  // Colombia (Bre-B) runtime payin
  breb_form_hint: "Se generará un código QR Bre-B para que el pagador transfiera desde su app bancaria.",
  breb_success_title: "Pago Bre-B creado",
  breb_success_id: "ID",
  breb_success_amount: "Monto a pagar:",
  breb_success_fee: "Comisión",
  breb_success_fee_free: "Sin comisión",
  breb_success_net: "Acreditamos",

  qr_panel_expires_in: "Vence en {{time}}",
  qr_panel_expired: "El QR venció y ya no se puede pagar. Crea un cobro nuevo.",
  qr_panel_copy_label: "Código para copiar y pegar",
  qr_panel_copy_button: "Copiar código",
  qr_panel_copied: "Código copiado",
  breb_success_expires: "Vence el",
  breb_success_copied: "Código copiado",
  breb_success_new: "Crear nuevo pago",
  breb_paid_title: "Pago acreditado",
  breb_paid_text: "El pagador completó la transferencia y el neto ya está en tu billetera.",
  payin_reversed_title: "Pago reversado",
  payin_reversed_text:
    "Este pago se había acreditado y después fue reversado: lo acreditado se descontó de tu billetera. Puedes crear un nuevo cobro.",
  breb_rejected_text: "El pago fue rechazado y no se acreditó. Puedes crear un nuevo cobro.",

  // Shared form fields
  form_payer_name_label: "Nombre del pagador",
  form_payer_name_placeholder: "Nombres",
  form_payer_last_name_label: "Apellido del pagador",
  form_payer_last_name_placeholder: "Apellidos",
  form_card_number_label: "Número de tarjeta",
  form_card_number_placeholder: "4111 1111 1111 1111",
  form_expiration_date_label: "Fecha de expiración (MM/YY)",
  form_expiration_date_placeholder: "MM/YY",
  form_cvv_label: "CVV",
  form_cvv_placeholder: "123",
  form_cuotes_label: "Cuotas",
  form_type_label: "Tipo",
  form_type_amount_sent: "Monto enviado",
  form_type_amount_received: "Monto recibido",
  fee_preview_title: "Desglose",
  fee_preview_fee: "Comisión",
  fee_preview_loading: "Calculando comisión…",
  mode_gross_label: "Quiero cobrar",
  mode_net_label: "Quiero recibir",
  mode_gross_hint: "Escribe lo que el pagador va a transferir; te decimos cuánto te queda.",
  mode_net_hint:
    "Escribe lo que quieres que llegue a tu billetera; te decimos cuánto debe transferir el pagador.",
  derived_net_text:
    "Recibes {{amount}} {{currency}} en tu billetera, después de {{fee}} {{currency}} de comisión.",
  derived_gross_text:
    "El pagador debe transferir {{amount}} {{currency}} para que te llegue completo, con {{fee}} {{currency}} de comisión.",
  fee_includes_taxes: "Incluye {{taxes}}.",
  pix_form_hint: "Se generará un QR Pix para que el pagador transfiera desde su app bancaria.",
  spei_form_hint:
    "Se generará una CLABE exclusiva para este cobro, con vencimiento, para que el pagador transfiera por SPEI desde su banco.",
  cbu_cvu_form_hint:
    "Las transferencias en pesos llegan a tu CVU fijo y se acreditan solas: aquí solo simulas la comisión.",
  pse_form_hint:
    "El pagador autoriza el débito en la página de su propio banco. Hay que registrar sus datos antes de generar el cobro.",
  nequi_form_hint: "La solicitud de cobro llega a la app Nequi del pagador; él la acepta desde su celular.",
  bancolombia_button_form_hint:
    "El pagador autoriza el pago directamente en Bancolombia. Hay que registrar sus datos antes de generar el cobro.",
  form_payer_rfc_label: "RFC del pagador (opcional)",
  form_payer_rfc_placeholder: "Déjalo vacío si no lo tienes",
  spei_success_title: "Cobro SPEI creado",
  spei_success_clabe_label: "CLABE para este cobro",
  spei_success_copy_button: "Copiar CLABE",
  spei_success_hint:
    "Esta CLABE es solo para este cobro y vence. El pagador transfiere por SPEI desde su banco y acreditamos apenas llegue.",
  spei_paid_title: "Pago acreditado",
  spei_paid_text: "La transferencia llegó y el neto ya está en tu billetera.",
  spei_rejected_text: "El pago fue rechazado y no se acreditó. Puedes crear un nuevo cobro.",
  panel_account_title: "Tu cuenta para recibir",
  panel_account_copy: "Copiar",
  panel_account_copied: "Copiado",
  panel_simulator_title: "Simula la comisión",
  panel_corridor_unavailable:
    "Este corredor todavía no está habilitado para tu organización. Escríbele a tu ejecutivo de cuenta.",
  corridor_unavailable_tooltip:
    "Corredor no habilitado todavía. Escríbele a tu ejecutivo de cuenta para activarlo.",
  simulator_gross_hint: "Escribe lo que te van a transferir; te decimos cuánto te queda.",
  simulator_net_hint:
    "Escribe lo que quieres que llegue a tu billetera; te decimos cuánto te deben transferir.",
  submit_gross: "Crear cobro por este monto",
  submit_net: "Crear cobro para recibir este monto",
  form_amount_label: "Monto",
  form_amount_usd_label: "Monto (USD)",
  form_payer_document_label: "CPF/CNPJ del pagador",
  form_payer_document_placeholder: "Solo números (11 o 14 dígitos)",
  form_description_label: "Descripción",
  form_description_placeholder: "Nota opcional",

  // Colombia form fields
  form_method_label: "Método de pago",
  form_method_placeholder: "Selecciona un método",
  form_document_type_label: "Tipo de documento",
  form_document_type_placeholder: "Selecciona un tipo",
  form_document_label: "Número de documento",
  form_document_placeholder: "1234567890",
  form_email_label: "Email",
  form_email_placeholder: "usuario@email.com",
  form_phone_label: "Teléfono",
  form_phone_placeholder: "+57 300 000 0000",
  form_bank_label: "Banco",
  form_bank_placeholder: "Selecciona un banco",
  form_nequi_phone_label: "Número de Nequi",

  // USA form / file upload
  form_receipt_label: "Comprobante",
  upload_instruction: "Haz clic para subir o arrastra aquí",
  upload_instruction_drop: "Suelta el archivo aquí",
  upload_helper: "Sube un comprobante de la transacción.",
  upload_constraints: "Máximo 10 MB • Imágenes (JPG, PNG, WebP)",
  upload_change: "Cambiar",
  upload_remove: "Quitar",
  upload_preview_alt: "Vista previa del comprobante",

  // Mexico runtime deposit panel (push-detected SPEI — no user-initiated create)

  // Argentina runtime deposit panel (push-detected CBU/CVU — no user-initiated create)
  arg_panel_instructions_title: "Deposita por transferencia (CBU/CVU)",
  arg_panel_instructions_body:
    "Tu organización tiene asignado un CVU de depósito. Realiza una transferencia en pesos argentinos desde tu banco o billetera — tú defines el monto — y los fondos se acreditarán automáticamente cuando el depósito se confirme.",
  arg_panel_cvu_hint: "¿No conoces tu CVU de depósito? Solicítalo a tu ejecutivo de cuenta.",
  arg_panel_deposits_title: "Depósitos recientes",
  arg_panel_deposits_empty: "Aún no registramos depósitos.",
  arg_panel_refresh_aria: "Actualizar depósitos",
  arg_panel_status_processing: "En proceso",
  arg_panel_status_credited: "Acreditado",
  arg_panel_status_failed: "Rechazado",

  // Validation
  validation_payer_name_required: "El nombre del pagador es requerido",
  validation_payer_name_max: "El nombre no puede exceder 100 caracteres",
  validation_amount_positive: "El monto debe ser mayor a 0",
  validation_payer_document: "Ingresa un CPF (11 dígitos) o CNPJ (14 dígitos) válido",
  validation_name_required: "El nombre es requerido",
  validation_last_name_required: "El apellido es requerido",
  validation_card_number_required: "El número de tarjeta es requerido",
  validation_expiration_date_required: "La fecha de expiración es requerida",
  validation_cvv_required: "El CVV es requerido",
  validation_cuotes_positive: "El número de cuotas debe ser mayor a 0",
  validation_card_number_invalid: "Número de tarjeta inválido",
  validation_expiration_date_invalid: "Fecha de expiración inválida (MM/YY)",
  validation_expiration_date_past: "La tarjeta está vencida",
  validation_cvv_invalid: "CVV inválido",
  validation_method_required: "El método de pago es requerido",
  validation_document_type_required: "El tipo de documento es requerido",
  validation_document_required: "El número de documento es requerido",
  validation_email_invalid: "El email no es válido",
  validation_phone_required: "El teléfono es requerido",
  validation_description_required: "La descripción es requerida",
  validation_bank_required: "El banco es requerido para PSE",
  validation_nequi_phone_required: "El número de Nequi es requerido",
  validation_voucher_required: "El comprobante es obligatorio",
  // Return page (/app/payins/result) — landing after the PSE bank flow
  return_breadcrumb: "Resultado del pago",
  return_missing_title: "Pago no encontrado",
  return_missing_body: "El enlace no incluye un pago válido. Revisa la actividad de pagos.",
  return_waiting_title: "Procesando tu pago…",
  return_waiting_body:
    "El banco está confirmando la transacción. Esta página se actualiza sola; puede tardar unos minutos.",
  return_confirmed_title: "¡Pago confirmado!",
  return_confirmed_body: "El dinero fue acreditado a la wallet",
  return_rejected_title: "Pago rechazado",
  return_rejected_body: "La transacción fue rechazada o falló en el banco. No se acreditó ningún saldo.",
  return_go_wallets: "Ir a wallets",
  return_pse_processing_title: "Procesando pago",
  return_pse_pending_callout:
    "Su transacción está PENDIENTE. Por favor verifique si el débito fue realizado en el banco. Para consultas, comuníquese al teléfono {{phone}} o al correo {{email}}",
  return_pse_autoupdate:
    "Esta página se actualizará automáticamente. Igualmente puede cerrar la ventana si desea y la transacción se confirmará en cuando se confirme el pago.",
  return_pse_info_cus: "CUS",
  return_pse_info_bank: "Banco",
  return_pse_info_amount: "Valor",
  return_pse_info_detail: "Detalle",
  return_pse_info_reference: "Referencia",
  return_pse_rejected_body: "La transacción no pudo ser procesada. Puedes intentar nuevamente.",
  return_pse_success_title: "Pago exitoso",
  return_pse_success_body:
    "Su transacción ha sido procesada. Recibirá una notificación de confirmación en las siguientes 24 horas.",
  return_pse_retry: "Intentar de nuevo",
  return_pse_home: "Regresar al inicio",
  pse_contact_phone: "+57 310 8343446",
  pse_contact_email: "operations@colocapayments.com",
  pse_contact_phone_label: "Teléfono",
  pse_contact_email_label: "Correo",

  // Colombia collection flow — shared by /app/payins (Colombia tab) and the COP wallet deposit modal
  step_amount: "Monto",
  step_payer: "Pagador",
  step_confirm: "Confirmar",
  button_continue: "Continuar",
  button_back: "Atrás",
  submit_pse: "Crear cobro PSE",
  submit_payer_rail: "Crear cobro",
  nequi_waiting_title: "La solicitud ya está en la app del pagador",
  nequi_waiting_body: "Enviamos el cobro al número {{phone}}. El pagador debe aceptarlo desde su app Nequi.",
  nequi_waiting_live: "Esperando la confirmación… puedes dejar esta ventana abierta.",
  nequi_waiting_new: "Crear otro cobro",
  rail_confirmed_title: "Pago acreditado",
  rail_confirmed_body: "El pagador aceptó la solicitud y el neto ya está en tu billetera.",
  rail_confirmed_new: "Crear otro cobro",
  rail_failure_title: "No se pudo completar el cobro",
  rail_failure_generic: "El cobro no se completó y no se acreditó nada. Puedes crear uno nuevo.",
  rail_failure_retry: "Crear otro cobro",
  method_choice_label: "¿Cómo va a pagar?",
  method_breb_desc: "Transfiere desde la app de su banco escaneando un QR.",
  method_pse_title: "PSE",
  method_pse_desc: "Autoriza el débito en la página de su banco. Se confirma solo.",
  method_nequi_desc: "Recibe la solicitud de cobro en su app Nequi y la acepta desde el celular.",
  method_bancolombia_desc: "Autoriza el pago directamente en Bancolombia. Se confirma solo.",
  method_unavailable: "No disponible por ahora para tu organización.",
  method_temporarily_disabled: "Temporalmente no disponible. Inténtalo más tarde.",
  amount_limit_hint_range: "Entre {{min}} y {{max}} por operación.",
  amount_limit_hint_max: "Hasta {{max}} por operación.",
  amount_limit_hint_min: "Desde {{min}} por operación.",
  amount_limit_hint_by_payer: "Hasta {{person}} para personas naturales y {{company}} para empresas.",
  amount_limit_above: "El monto supera el máximo permitido de {{max}}.",
  amount_limit_below: "El monto está por debajo del mínimo de {{min}}.",
  method_limit_up_to: "Hasta {{max}}.",
  method_limit_up_to_by_payer: "Hasta {{person}} (personas) · {{company}} (empresas).",
  confirm_limit_above: "Para {{payer}} el máximo por operación es {{max}}. Ajusta el monto para continuar.",
  confirm_limit_below: "Para {{payer}} el mínimo por operación es {{min}}. Ajusta el monto para continuar.",
  confirm_limit_edit_amount: "Editar monto",
  limit_payer_person: "personas naturales",
  limit_payer_company: "empresas",
  confirm_amount: "El pagador envía",
  confirm_net: "Acreditamos",

  // PSE payer form
  pse_voucher_amount_label: "A pagar",
  pse_voucher_reference_label: "Referencia",
  pse_voucher_copy: "Copiar referencia",
  pse_voucher_copied: "Referencia copiada",
  pse_group_identity: "Quién paga",
  pse_group_contact: "Contacto y banco",
  pse_person_type_label: "Tipo de persona",
  pse_person_natural: "Persona natural",
  pse_person_juridica: "Empresa",
  pse_document_type_label: "Tipo",
  pse_document_number_label: "Número de documento",
  pse_document_placeholder: "Solo números",
  pse_document_invalid: "Escribe un documento de 4 a 15 dígitos",
  pse_name_label: "Nombre completo",
  pse_name_placeholder: "Como aparece en el documento",
  pse_email_label: "Correo",
  pse_email_placeholder: "correo@ejemplo.com",
  pse_email_invalid: "Escribe un correo válido",
  pse_phone_label: "Celular",
  pse_phone_placeholder: "3001234567",
  pse_phone_invalid: "Escribe un celular colombiano de 10 dígitos que empiece por 3",
  mobile_phone_invalid: "Escribe un celular de 10 dígitos que empiece por 3",
  pse_address_label: "Dirección",
  pse_address_placeholder: "Calle 100 # 10-20, Bogotá",
  pse_bank_label: "Banco",
  pse_bank_placeholder: "Busca tu banco",
  pse_bank_loading: "Cargando bancos…",
  pse_bank_empty: "Ningún banco coincide",
  pse_bank_error: "No pudimos cargar la lista de bancos.",
  pse_bank_retry: "Reintentar",
  pse_bank_hint: "Te llevamos a la página del banco para autorizar el débito.",
  pse_max_length: "Máximo {{max}} caracteres",

  // PSE handoff to the bank, and the failure that stops it
  pse_handoff_title: "Creando la transacción",
  pse_handoff_body: "Estamos preparando el pago con el banco. No cierres esta ventana.",
  pse_handoff_cancel: "Cancelar",
  pse_failure_title: "No pudimos crear el pago",
  pse_failure_limit:
    "El monto de la transacción excede los límites establecidos. Por favor comuníquese con nuestras líneas de atención al cliente.",
  pse_failure_generic:
    "No se pudo crear la transacción. Por favor intente más tarde o comuníquese con nuestras líneas de atención al cliente.",
  pse_failure_retry: "Intentar de nuevo",
  pse_confirmed_title: "Pago acreditado",
  pse_confirmed_body: "El pagador autorizó el débito y el neto ya está en tu billetera.",
  pse_confirmed_new: "Crear otro cobro",

  // Own Bre-B key and the QR placard
  qr_card_title: "Paga con {{rail}}",
  qr_card_hint: "Escanéalo desde la app de tu banco",
  qr_card_amount_label: "Valor a pagar",
  qr_card_share: "Compartir",
  qr_card_download: "Descargar",
  qr_card_key_label: "o transfiere a la llave",
  breb_key_label: "Tu llave Bre-B",
  breb_key_copy: "Copiar llave",
  breb_key_copied: "Llave copiada",
  breb_key_copy_error: "No pudimos copiar. Selecciona la llave y cópiala a mano.",
  breb_key_share: "Compartir",
  breb_key_share_text: "Transfiéreme por Bre-B a la llave {{key}} desde la app de tu banco.",
  breb_key_holder_hint: "En la app del banco aparecerá «{{name}}» como destinatario.",
  breb_key_pending_title: "Estamos terminando de registrar tu llave",
  breb_key_pending_body:
    "Bre-B la está confirmando. Suele tardar unos segundos; puedes cerrar esta ventana y volver más tarde.",
  breb_key_howto_title: "¿Cómo recargar con tu llave?",
  breb_key_howto_step1: "Copia tu llave.",
  breb_key_howto_step2: "Abre la app de tu banco y elige transferir con llave Bre-B.",
  breb_key_howto_step3:
    "Pega la llave, escribe el monto y confirma. El dinero llega a tu billetera COP en segundos.",
  breb_key_qr_title: "Tu llave y tus cobros con monto",
  breb_key_qr_body:
    "Para un cobro con monto, comparte el QR de ese cobro: una transferencia escrita a tu llave llega a tu billetera, pero como un recaudo aparte, y el cobro queda sin pagar.",
  breb_key_qr_fallback:
    "Si eliminas una llave, dejarás de recibir en ella y en su QR para cualquier monto. Si era tu llave principal, tus próximos cobros con monto usarán la siguiente, o la llave general de Coloca si no te queda ninguna.",
  breb_key_compact_create: "Crea tu llave Bre-B",
  breb_key_compact_create_hint: "Recibe sin QR, desde cualquier banco",
  breb_key_entry_cta_view: "Ver cómo recargar",
  breb_key_bounds_rule_label: "Qué pasa fuera de este rango",
  breb_key_bounds_rule_range:
    "Si te envían menos de {{min}} o más de {{max}}, el pago va a fallar. Aplica a tu llave y a tu QR.",
  breb_key_bounds_rule_min:
    "Si te envían menos de {{min}}, el pago va a fallar. Aplica a tu llave y a tu QR.",
  breb_key_bounds_rule_max: "Si te envían más de {{max}}, el pago va a fallar. Aplica a tu llave y a tu QR.",
  breb_key_entry_or_amount: "O crea un cobro con monto",
  breb_key_wizard_step_intro: "Qué es",
  breb_key_wizard_step_choose: "Tu llave",
  breb_key_wizard_step_confirm: "Confirmar",
  breb_key_intro_title: "Recibe plata sin QR",
  breb_key_intro_body:
    "Tu llave Bre-B funciona como un alias de tu billetera COP. Quien te pague la escribe en la app de su banco y el dinero llega en segundos. Como no hay nada que escanear, funciona desde el mismo celular.",
  breb_key_intro_point_banks: "Desde cualquier banco o billetera del país, 24/7.",
  breb_key_intro_point_uses: "Sirve para recargar tu billetera o para que tus clientes te paguen.",
  breb_key_intro_point_qr: "Además tendrás un QR para cualquier monto, listo para imprimir o compartir.",
  breb_key_intro_cta: "Elegir mi llave",
  breb_key_choose_title: "Elige tu llave",
  breb_key_choose_body: "Así la escribirán quienes te paguen. Siempre empieza por @coloca.",
  breb_key_option_document: "Con tu documento",
  breb_key_option_document_hint: "Incluye tu número de documento: quien reciba tu llave lo verá.",
  breb_key_option_phone: "Con tu celular",
  breb_key_option_phone_verified_hint:
    "Es el celular que registraste al verificar tu cuenta: quien reciba tu llave lo verá.",
  breb_key_option_generated: "Llave asignada",
  breb_key_option_generated_hint: "Generamos una llave única para tu cuenta.",
  breb_key_availability_available: "Disponible",
  breb_key_availability_taken: "Ya está en uso",
  breb_key_availability_unknown: "No pudimos verificarla",
  breb_key_availability_checking: "Verificando…",
  breb_key_availability_recheck: "Verificar de nuevo",
  breb_key_taken_in_coloca: "Ya la registró otra organización de Coloca. Si es tuya, escríbenos a soporte.",
  breb_key_taken_in_coloca_notified:
    "Ya la registró otra organización de Coloca. Le avisamos por correo; si es tuya, escríbenos a soporte.",
  breb_key_taken_elsewhere: "Ya está registrada en otra entidad de Bre-B. Si es tuya, escríbenos a soporte.",
  breb_key_all_taken_title: "Todas tus opciones de llave ya están registradas",
  breb_key_all_taken_body:
    "Abajo verás dónde está registrada cada una. Si alguna es tuya, escríbenos a soporte.",
  breb_key_choose_cta: "Continuar",
  breb_key_confirm_title: "Confirma tu llave",
  breb_key_confirm_permanent: "Se queda hasta que la elimines. Si la eliminas, puedes crear otra.",
  breb_key_delete: "Eliminar llave",
  breb_key_delete_title: "¿Eliminar la llave {{key}}?",
  breb_key_delete_body:
    "Dejarás de recibir transferencias a {{key}} y pagos con tu QR para cualquier monto. Tus próximos cobros con monto usarán la llave general de Coloca, y después podrás crear una llave nueva.",
  breb_key_delete_body_final:
    "Dejarás de recibir transferencias a {{key}} y pagos con tu QR para cualquier monto. Tus próximos cobros con monto usarán la llave general de Coloca. Para volver a tener una llave propia, escribe a soporte.",
  breb_key_delete_confirm: "Eliminar llave",
  breb_key_delete_anyway: "Eliminar de todos modos",
  breb_key_delete_cancel: "Cancelar",
  breb_key_delete_done: "Eliminaste la llave {{key}}.",
  breb_key_delete_two_factor_required: "Activa la autenticación en dos pasos para eliminar la llave.",
  breb_key_delete_two_factor_description:
    "Escribe el código de tu app de autenticación para eliminar la llave {{key}}.",
  breb_key_confirm_qr: "Mientras exista, tus códigos QR de cobro la usarán.",
  breb_key_confirm_cta: "Crear mi llave",
  breb_key_creating: "Registrando tu llave en Bre-B…",
  breb_key_back: "Atrás",
  breb_key_close: "Cerrar",
  breb_key_ready_title: "¡Tu llave está lista!",
  breb_key_ready_body: "Cópiala o compártela y recibe desde cualquier banco.",
  breb_key_error_title: "No pudimos crear tu llave",
  breb_key_retry: "Intentar de nuevo",
  breb_key_load_error: "No pudimos cargar tu llave Bre-B.",
  breb_key_verify_title: "Verifica tu cuenta para crear tu llave",
  breb_key_verify_body:
    "La llave recibe dinero de cualquier banco a nombre de tu organización, por eso pedimos la cuenta verificada.",
  breb_key_verify_cta: "Verificar mi cuenta",
  breb_key_rail_disabled: "Los cobros Bre-B no están disponibles para tu organización en este momento.",
  breb_key_not_enabled: "La llave Bre-B todavía no está disponible para tu cuenta.",
  breb_key_no_options: "No encontramos datos para armar tu llave. Escríbenos a soporte.",
  breb_key_read_only:
    "Tu organización todavía no tiene llave Bre-B. Pídele a un administrador de tu cuenta que la cree.",
  breb_key_availability_unknown_body:
    "No pudimos confirmar si esta llave está libre. Vuelve a verificarla en unos segundos.",
  breb_key_choose_other: "Elegir otra llave",
  breb_key_choice_gone: "Esa llave ya no está disponible. Vuelve atrás y elige otra.",
  breb_key_create_amount_charge: "Crear un cobro con monto",
  breb_key_bounds_title: "Montos que recibe tu llave",
  breb_key_bounds_min: "Monto mínimo",
  breb_key_bounds_max: "Monto máximo",
  breb_key_bounds_hint:
    "El banco de quien te paga rechaza las transferencias por fuera de este rango antes de enviar el dinero.",
  breb_key_static_qr_title: "Tu QR para cualquier monto",
  breb_key_static_qr_body:
    "Imprímelo o compártelo: quien lo escanee escribe el monto en la app de su banco y el dinero llega a tu billetera COP.",
  breb_key_static_qr_generating: "Estamos generando tu QR. Aparecerá aquí en unos segundos.",
  breb_key_pending_badge: "En registro",
  breb_key_last_failure_title: "Tu llave no quedó registrada",
  breb_key_last_failure_taken: "La llave {{key}} ya estaba en uso en otra entidad. Elige otra opción.",
  breb_key_last_failure_rejected: "Bre-B no aceptó la llave {{key}}. Elige otra opción.",
  breb_key_last_failure_unfinished:
    "No pudimos terminar de registrar la llave {{key}}. Intenta de nuevo o escríbenos a soporte.",
  breb_key_last_failure_custom_taken:
    "La llave {{key}} ya estaba en uso en otra entidad. Escríbenos a soporte si quieres otra llave personalizada.",
  breb_key_last_failure_custom_rejected:
    "Bre-B no aceptó la llave {{key}}. Escríbenos a soporte si quieres otra llave personalizada.",
  breb_key_last_failure_custom_unfinished:
    "No pudimos terminar de registrar la llave {{key}}. Escríbenos a soporte para revisarla.",
  breb_key_primary_label: "Tu llave principal",
  breb_key_entry_more: "+{{count}}",
  breb_key_entry_more_label: "Llaves adicionales: {{count}}",
  breb_key_list_title: "Tus llaves",
  breb_key_list_hint: "Tus cobros con monto usan la llave principal. Al crear un cobro puedes elegir otra.",
  breb_key_list_add: "Agregar otra llave",
  breb_key_primary_badge: "Principal",
  breb_key_source_document: "Documento",
  breb_key_source_phone: "Celular",
  breb_key_source_generated: "Asignada",
  breb_key_source_custom: "Personalizada",
  breb_key_set_primary: "Usar como principal",
  breb_key_set_primary_done: "{{key}} es ahora tu llave principal.",
  breb_key_delete_body_primary:
    "Dejarás de recibir transferencias a {{key}} y pagos con su QR para cualquier monto. Tus próximos cobros con monto usarán {{next}}, que pasa a ser tu llave principal.",
  breb_key_delete_body_secondary:
    "Dejarás de recibir transferencias a {{key}} y pagos con su QR para cualquier monto. Tu llave principal no cambia.",
  breb_key_add_cancel: "Cancelar",
  breb_key_add_none: "Ya tienes todas las llaves que puedes crear con los datos de tu cuenta.",
  breb_key_options_load_error: "No pudimos cargar las opciones de llave.",
  breb_key_confirm_qr_secondary:
    "Tus cobros con monto seguirán usando tu llave principal. Puedes cambiarla cuando quieras.",
  breb_key_select_label: "Llave que recibe el pago",
  breb_key_select_hint: "El QR del cobro se genera sobre esta llave.",
  breb_key_select_option_primary: "{{source}} · Principal",
  payin_detail_receiving_key: "Llave que recibió",
  payin_detail_channel: "Cómo llegó",
  payin_detail_channel_qr: "Código QR",
  payin_detail_channel_key_unnamed: "Transferencia a tu llave Bre-B",
  payin_detail_channel_static_qr: "QR para cualquier monto",
  payin_detail_payer: "Pagador",
  payin_detail_sent: "Enviado por el pagador",
  payin_detail_fee: "Comisión",
  payin_detail_credited: "Acreditado",

  breb_key_show_qr: "Ver QR",
  breb_key_quick_title: "Tus llaves Bre-B",
  breb_key_quick_hint: "Compártelas para recibir desde cualquier banco, por el monto que quieran enviarte.",
  breb_key_quick_manage: "Gestionar",
  breb_key_qr_view_title: "QR de tu llave",
  breb_key_qr_view_details: "Ver detalles de la llave",
  breb_key_payment_received_title: "Llegó un pago",
  breb_key_payment_received_announce: "Llegó un pago de {{amount}}",
  breb_key_payment_received_from: "De {{name}}",
  breb_key_payment_received_credited: "A tu billetera llegan {{amount}} después de la comisión.",
  breb_key_payment_received_view: "Ver transacción",
  breb_key_payment_received_view_short: "Ver",
  breb_key_payment_received_earlier: "También llegaron",
  breb_key_payment_listening: "Te avisamos aquí apenas llegue un pago.",
  breb_key_payment_listening_more: "Te avisamos aquí si llega otro.",
  breb_key_payment_sound_mute: "Silenciar el sonido de pagos",
  breb_key_payment_sound_unmute: "Activar el sonido de pagos",
};
